export default __webpack_public_path__ + "static/media/paystack.482ce344.svg";